<template>
  <slot v-bind="{ dismiss }" v-if="!dismissed"></slot>
</template>
<script>
import Cookies from 'js-cookie'

export default {
  props: {
    cookieKey: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      dismissed: this.$props.cookieKey !== null && Cookies.get('dis' + this.$props.cookieKey) === 'cls',
    }
  },
  methods: {
    dismiss() {
      this.dismissed = true
      if (this.$props.cookieKey) {
        Cookies.set('dis' + this.$props.cookieKey, 'cls')
      }
    },
  },
}
</script>
